import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';
import FormGroup from '~/components/form/FormGroup';

export default function McmCustomForm(): ReactElement {
  return (
    <FormGroup>
      <FormHorizontal name="description" label="Description">
        <ZodFieldTextarea name="description" />
      </FormHorizontal>
      <FormHorizontal name="revenue" label="Revenue">
        <ZodFieldInput type="number" name="revenue" />
      </FormHorizontal>
      <FormHorizontal name="taxable" label="Taxable">
        <ZodFieldCheckbox name="taxable" />
      </FormHorizontal>
      {/* Kept through an edit, so the Bleenk package this line delivers stays attached. */}
      <ZodFieldHidden name="package" />
      {/* And the slideshow that package includes (McmOrder.slideshows). */}
      <ZodFieldHidden name="slideshow" />
    </FormGroup>
  );
}
